import InboundActions from '@intercom/embercom-composer/mixins/inbound-actions';
import { alias, or } from '@ember/object/computed';
import { schedule } from '@ember/runloop';
import Em from 'ember';
export default Em.Component.extend(InboundActions, {
  isEmojiVisible: false,
  isMentionsVisible: false,
  isSavedReplyVisible: false,
  selection: alias('composerState.selection'),
  eventNameForKeyEvent(e) {
    let keyCode = e.which || e.keyCode;
    let map = {
      9: 'onTab',
      13: 'onEnter',
      27: 'onEsc',
      38: 'onUp',
      40: 'onDown'
    };
    return map[keyCode];
  },
  activeTypeAhead: Em.computed('isEmojiVisible', 'isMentionsVisible', 'isSavedReplyVisible', function () {
    if (this.get('isEmojiVisible')) {
      return this.get('emojiInserterComponent');
    }
    if (this.get('isMentionsVisible')) {
      return this.get('mentionsInserterComponent');
    }
    if (this.get('isSavedReplyVisible')) {
      return this.get('savedReplyInserterComponent');
    }
  }),
  isTypeAheadVisible: or('isEmojiVisible', 'isMentionsVisible', 'isSavedReplyVisible'),
  actions: {
    typeaheadVisiblityChanged(isVisible) {
      this._modifyTypeaheadVisibility('isMentionsVisible', isVisible);
    },
    mentionsVisiblityChanged(isVisible) {
      this._modifyTypeaheadVisibility('isMentionsVisible', isVisible);
    },
    emojiVisiblityChanged(isVisible) {
      this._modifyTypeaheadVisibility('isEmojiVisible', isVisible);
    },
    savedReplyVisiblityChanged(isVisible) {
      schedule('afterRender', () => {
        this.set('isSavedReplyVisible', isVisible);
        this.get('visibilityChanged')(this.get('isTypeAheadVisible'));
      });
    },
    refresh() {
      this.get('updateDomAndSelection')();
    },
    keyDown(e) {
      let eventName = this.eventNameForKeyEvent(e);
      let activeTypeAhead = this.get('activeTypeAhead');
      if (eventName && activeTypeAhead) {
        activeTypeAhead.send(eventName);
        e.preventDefault();
        e.stopPropagation();
      }
    },
    typeAheadWasInserted(params) {
      this.typeAheadWasInserted?.(params);
    },
    getTriggerCoords(triggerCharacter) {
      return this.get('getTriggerCoords')(triggerCharacter);
    }
  },
  _modifyTypeaheadVisibility(isVisiblePropertyName, isVisible) {
    schedule('afterRender', () => {
      this.set(isVisiblePropertyName, isVisible);
      this.get('visibilityChanged')(this.get('isTypeAheadVisible'));
    });
  }
});